<template>
  <div class="langPosition">
    <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
      v-if="locales.length"
    >
      <template v-slot:activator>
        <v-btn fixed bottom right small fab dark class="flex items-center langDropdownButton">
          <v-icon v-if="fab" dark class="flagActive">close</v-icon>
          <img v-else :src="`/flags/flag_${$i18n.locale}.svg`" alt="flag" class="flagShadow" />
        </v-btn>
      </template>
      <ul ref="dropdown" class="langBox">
        <li v-for="(lang, idx) in locales" :key="idx">
          <a
            href="#"
            class="flex langHover"
            @click.prevent="setLocale(lang.shortName)"
            @keydown.up.exact.prevent
            @keydown.tab.exact="focusNext(false)"
            @keydown.down.exact.prevent="focusNext(true)"
            @keydown.esc.exact="hideDropdown"
          >
            <img :src="lang.flag" :alt="lang.longName" class="flag" v-if="lang.flag" />
            <span class="localLang">{{ lang.localName }}</span>
          </a>
        </li>
      </ul>
    </v-speed-dial>

    <!-- <button
      href="#"
      class="flex items-center langDropdownButton"
      @click="toggleVisibility"
      @keydown.space.exact.prevent="toggleVisibility"
      @keydown.esc.exact="hideDropdown"
      @keydown.shift.tab="hideDropdown"
      @keydown.up.exact.prevent="startArrowKeys"
      @keydown.down.exact.prevent="startArrowKeys"
    >
      <img :src="`/flag_${$i18n.locale}.svg`" alt="flag" class="flagShadow" />
    </button>
    <transition name="dropdown-fade">
      <ul v-if="isVisible" ref="dropdown" v-on-clickaway="hideDropdown" class="langBox">
        <li v-for="(lang, idx) in langs" :key="idx">
          <a
            href="#"
            class="flex langHover"
            @click.prevent="setLocale(lang.shortName)"
            @keydown.up.exact.prevent
            @keydown.tab.exact="focusNext(false)"
            @keydown.down.exact.prevent="focusNext(true)"
            @keydown.esc.exact="hideDropdown"
          >
            <img :src="lang.flag" :alt="lang.longName" class="flag" />
            <span class="localLang">{{ lang.localName }}</span>
          </a>
        </li>
      </ul>
    </transition> -->
  </div>
</template>

<script>
import { getSupportedLocales } from '@/utils/i18n/supportedLocales';

export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      isVisible: false,
      focusedIndex: 0,
      locales: getSupportedLocales(),
      direction: 'top',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
    };
  },

  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
    hideDropdown() {
      this.isVisible = false;
      this.focusedIndex = 0;
    },
    startArrowKeys() {
      if (this.isVisible) {
        this.$refs.dropdown.children[0].children[0].focus();
      }
    },
    focusPrevious(isArrowKey) {
      this.focusedIndex -= 1;
      if (isArrowKey) {
        this.focusItem();
      }
    },
    focusNext(isArrowKey) {
      this.focusedIndex += 1;
      if (isArrowKey) {
        this.focusItem();
      }
    },
    focusItem() {
      this.$refs?.dropdown?.children?.[this.focusedIndex]?.children?.[0]?.focus();
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      // localStorage.setItem('lang', locale);

      this.hideDropdown();
    },
  },

  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },
};
</script>

<style scoped>
.langPosition {
  z-index: 99999999;
  position: fixed;
  display: flex;
  justify-content: center;
  bottom: 30px;
  right: 20px;
}

.langBox {
  user-select: none;
  padding: 5px 5px 5px -5px;
  width: max-content;
  box-shadow: 0px 3px 6px rgb(130, 130, 130);
}

.localLang {
  position: absolute;
  margin-top: 3px;
  font-size: 18px;
  padding-left: 15px;
  font-weight: 400;
  vertical-align: middle;
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.1s ease-in-out;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

.langDropdownButton {
  outline: none;
  cursor: pointer !important;
  background-color: transparent !important;
  border: none;
  padding-right: 0px;
}

.shortName {
  margin-top: 5px !important;
}

ul {
  text-align: left;
  min-width: 155px;
  border-radius: 8px;
  background: white;
  z-index: 500;
  position: absolute;
  list-style: none;
  padding: 10px 10px !important;
  margin: 0px !important;
  bottom: 5px;
  right: 10px;
}
ul > li {
  padding: 5px 0;
}

.flag {
  width: 30px;
}

.flagShadow {
  border-radius: 50px;
  box-shadow: 0px 3px 3px rgb(130, 130, 130);
  width: 40px;
}

.flagActive {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
  background-color: #ba2127;
}

.langHover {
  margin: 10px;
  text-decoration: none;
  color: #222;
  transition: all 0.1s ease-in-out;
}
.langHover:hover {
  color: #007aff;
}
</style>
